type CurrencyOptionType = {
  label: string
  value: string
}

export const getCurrenciesOptions = (currencies: string[]): CurrencyOptionType[] =>
  currencies.map(currency => ({
    value: currency,
    label: currency,
  }))
